export const errorNames: { [key: string]: string } = {
    internalError: 'INTERNAL_ERROR',
    noTaxPeriodAvailable: 'NO_TAX_PERIOD_AVAILABLE',
    mindreAarigKunde: 'MINDREAARIG_KUNDE',
    dnumberCustomer: 'DNUMMER_KUNDE',
    customerInfoFailSDC: 'HENT_KUNDEINFO_SDC_FEILET',
    aaaSolitity: 'AAA_SOLIDITY',
    aaaSoliditet: 'AAA_SOLIDITET',
    kyc_blocked_error: 'kyc_blocked_error',
    kyc_error: 'kyc_error',
    agriInvalidCustomer: 'AGRICARD_UGYLDIG_MEDLEMSTYPE',
    agriInvalidCard: 'AGRICARD_UGYLDIG_KORTTYPE',
    agriTokenParseFailed: 'AGRICARD_TOKEN_PARSING_FEILET',
    agriTokenValidFailed: 'AGRICARD_TOKEN_VALIDERING_FEILET',
    invalidNafData: 'NAF_DATA_UGYLDIG',
};
export const serviceError = 'service_error';
export const genericError = 'generic_error';

export const getErrorMessage = (errorName: string, isServiceError?: boolean) => {
    let errorMessage: string = isServiceError ? serviceError : genericError;

    if (errorNames[errorName]) errorMessage = errorNames[errorName];

    return errorMessage;
};
